import React from 'react'
import { Trans } from '@lingui/macro'

import { OrganisationRoleEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { useLogout } from 'front-end/src/public-api/hooks/useLogout'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

import UserIcon from '../common/user/user-icon/UserIcon'
import { linkBuilder } from '../../../../shared/linkBuilder'
import { navigateTo } from '../../app/util/appHistory'
import { useUserDropdownQuery } from './UserDropdown.codegen'
import { Box, LinkBox, LinkOverlay } from 'front-end/src/components'

export const UserDropdown = () => {
  const logout = useLogout()
  const { session } = usePublicApiSession()
  const user = session?.user

  const isAdmin = user?.organisation_role === OrganisationRoleEnum.ADMIN

  const { data } = useUserDropdownQuery({
    fetchPolicy: 'cache-first',
    skip: isAdmin
  })

  if (!user) {
    return null
  }

  return (
    <div className="MainHeader__user__list">
      <LinkBox
        className="DropdownLink MainHeader__user__section"
        onClick={() => {
          navigateTo(linkBuilder.userDetail('me', 'basic'))
        }}
      >
        <UserIcon user={user} size={28} />
        <Box className="user-text" minW="115px">
          <span className="user-name">{user.display_name}</span>
          <Box className="text-small" whiteSpace="nowrap">
            {data?.organisation?.can_students_update_profile || isAdmin ? (
              <Trans>Edit your profile</Trans>
            ) : (
              <Trans>View your profile</Trans>
            )}
          </Box>
        </Box>
      </LinkBox>
      <div className="DropdownDivider" />

      {user.organisation_role !== OrganisationRoleEnum.STUDENT && (
        <LinkOverlay
          className="DropdownLink"
          to="http://support.looop.co"
          isExternal
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="icon icon-question" /> <Trans>Support</Trans>
        </LinkOverlay>
      )}
      <LinkBox
        className="DropdownLink MainHeader__user__list__logout"
        onClick={() => {
          logout(session?.session_attributes_data.ssoLogoutURL || '')
        }}
      >
        <i className="icon icon-logout" /> <Trans>Log out</Trans>
      </LinkBox>
    </div>
  )
}
